import { useEffect, useState } from 'react';
import { AlertData, removeAlert, subscribe } from '../utils/showAlert';

/**
 * Displays all alerts in the top-right corner
 */
const AlertDisplay = () => {
    const [alerts, setAlerts] = useState<AlertData[]>([]);

    useEffect(() => {
        return subscribe(setAlerts);
    }, []);

    if (alerts.length === 0) {
        return null;
    }

    return (
            <div style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                zIndex: 9999,
                maxWidth: '500px',
                width: '100%'
            }}>
                {alerts.map((alert) => (
                        <div key={alert.id} style={{ marginBottom: '10px' }}>
                            <div className={`alert ${alert.variant} alert-dismissible fade show`} role="alert">
                                <h4 className="alert-heading">{alert.heading}</h4>
                                <p>{alert.message}</p>
                                <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => removeAlert(alert.id)}
                                        aria-label="Close"
                                ></button>
                            </div>
                        </div>
                ))}
            </div>
    );
}

export default AlertDisplay;
